import { render, staticRenderFns } from "./grmidland.vue?vue&type=template&id=710cf268&"
import script from "./grmidland.vue?vue&type=script&lang=js&"
export * from "./grmidland.vue?vue&type=script&lang=js&"
import style0 from "./grmidland.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports